import * as propertyTypes from "../property_types.js"

export class UiTextboxProps extends propertyTypes.AppBaseComponentProps {

    private isPasswordMetadata = new propertyTypes.CheckBoxProperty("isPassword", "Is password");
    public isPassword: boolean;

    private maxLengthMetadata = new propertyTypes.TextProperty("maxLength", "Max length");
    public maxLength: number;

    private multiLineMetadata = new propertyTypes.CheckBoxProperty("multiLine", "Multi line");
    public multiLine: boolean;

    private triggerOnChangeMetadata = new propertyTypes.CheckBoxProperty("triggerOnChange", "Trigger on change");
    public triggerOnChange: boolean;

    private faIconNameMetadata = new propertyTypes.FontawesomeIconProperty("faIconName", "FaIcon name");
    public faIconName: string;

    private textboxMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.textboxMetadataAll = baseMetaData.concat([this.isPasswordMetadata, this.maxLengthMetadata, this.multiLineMetadata, this.triggerOnChangeMetadata, this.faIconNameMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.textboxMetadataAll;
    }
}